import {Part} from "@app/core/part/domain/part";

export abstract class PartDAO {
  abstract save(part: Part): Promise<Part>;
  abstract get(partID: number): Promise<Part>;
  abstract saveIdList(idList: number[]): Promise<number[]>;
  abstract getIdList(): Promise<number[]>;
}
